const _excluded = ["style", "className", "item", "active", "collapsed", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { EXTERNAL_ICON_CLASSNAME } from './consts';
const StyledLi = styled('li').withConfig({
  displayName: "SideNavigationItem__StyledLi",
  componentId: "sc-wlo0hi-0"
})({
  margin: 0,
  padding: 0
});
const BaseStyledA = styled.a.withConfig({
  displayName: "SideNavigationItem__BaseStyledA",
  componentId: "sc-wlo0hi-1"
})(_objectSpread(_objectSpread({}, theme.typography.bodyMedium), {}, {
  display: 'flex',
  alignItems: 'center',
  color: theme.colors.charcoal700,
  margin: 0,
  padding: '10px 12px',
  textAlign: 'inherit',
  textDecoration: 'none',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    color: theme.colors.adskBlue500,
    [".".concat(EXTERNAL_ICON_CLASSNAME)]: {
      backgroundColor: theme.colors.adskBlue500
    }
  },
  '&:active': {
    cursor: 'pointer',
    color: theme.colors.adskBlue700
  }
}));
const ActiveStyledA = styled(BaseStyledA).withConfig({
  displayName: "SideNavigationItem__ActiveStyledA",
  componentId: "sc-wlo0hi-2"
})({
  boxShadow: "inset 2px 0 0 0 ".concat(theme.colors.adskBlue500),
  backgroundColor: theme.colors.white,
  color: theme.colors.adskBlue500
});
const InactiveStyledA = styled(BaseStyledA).withConfig({
  displayName: "SideNavigationItem__InactiveStyledA",
  componentId: "sc-wlo0hi-3"
})({
  '&:visited': {
    color: theme.colors.charcoal700
  },
  '&:hover': {
    color: theme.colors.adskBlue500
  }
});
const SideNavigationItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      item,
      active,
      collapsed,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const StyledA = active ? ActiveStyledA : InactiveStyledA;
  return /*#__PURE__*/React.createElement(StyledLi, {
    "data-collapsed": collapsed
  }, /*#__PURE__*/React.createElement(StyledA, _extends({}, props, {
    ref: ref,
    className: className,
    "data-active": active
  }, item.onClick ? {
    onClick: item.onClick
  } : {
    href: item.url
  }, {
    style: style
  }), children));
});
SideNavigationItem.displayName = 'SideNavigationItem';
SideNavigationItem.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** children of SideNavigationItem */
  children: PropTypes.node,
  /** Item active state */
  active: PropTypes.bool,
  /** Item collapsed state */
  collapsed: PropTypes.bool,
  /** Item */
  item: PropTypes.object.isRequired
};
export default SideNavigationItem;
//# sourceMappingURL=SideNavigationItem.js.map